import React from 'react'

type Props = { src: string, alt: string }
const CoverImage: React.FC<Props> = ({ src, alt }) => {
  const dimensions = 'h-60 w-60 sm:h-64 sm:w-64'
  return (
    <div className='sm:w-full relative h-[230px] sm:h-auto sm:inline-block'>
      <div className={`z-0 absolute top-0 left-[50%] translate-x-[-50%] bg-soft-green opacity-60 rounded-[50px] ${dimensions} rotate-[17deg]`} />
      <div className={`z-0 absolute top-0 left-[50%] translate-x-[-50%] bg-deep-green opacity-60 rounded-[50px] ${dimensions} rotate-[51deg]`} />
      <div className={`z-0 absolute top-0 left-[50%] translate-x-[-50%] bg-electric-green opacity-40 rounded-[50px] ${dimensions} rotate-[34deg]`} />
      <div className='sm:w-full sm:h-full z-90 absolute top-0 left-[50%] translate-x-[-50%]'><img src={src} alt={alt} className={`${dimensions} mx-auto object-cover rounded-[50px] shadow`} /></div>
    </div>
  )
}

export default CoverImage
